import { render, staticRenderFns } from "./ContactVyskovDoplatek.vue?vue&type=template&id=680ebce0&"
import script from "./ContactVyskovDoplatek.vue?vue&type=script&lang=js&"
export * from "./ContactVyskovDoplatek.vue?vue&type=script&lang=js&"
import style0 from "./ContactVyskovDoplatek.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VFileInput,VRow})
